import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import CCApp from './Apps/CC/src/App';
import TCApp from "./Apps/TC/src/App";
import HSApp from "./Apps/HS/src/App";

import Home from "./Pages/Home/Home";
import EmailSettings from "./Pages/EmailSettings/EmailSettings";
import ToastContext from './Context/Toaster/Toaster';
import AccessDenied from './Pages/AccesDenied/AccessDenied';

const App = () => {

  return (
    <Router>
      <ToastContext />
      <Routes>
        <Route path="/cc/*" element={<CCApp />} />
        <Route path="/tc/*" element={<TCApp />} />
        <Route path="/hs/*" element={<HSApp />} />

        <Route path='/' element={<Home />} />
        <Route path='/email-settings' element={<EmailSettings />} />
        <Route path="/access-denied" element={<AccessDenied />} />
        <Route path="*" element={<div>Page Not Found</div>} />
      </Routes>
    </Router>
  );
};

export default App;
